// extracted by mini-css-extract-plugin
export default {"footerPayments":"FooterPayments_footerPayments__3TCLl","footerPaymentIcons":"FooterPayments_footerPaymentIcons__W7dku","footerPaymentIcon":"FooterPayments_footerPaymentIcon__KU5ev"};